const isAnimationReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const desktopVideo = document.getElementById('c-page-masthead__video-element') || document.getElementById('c-event-masthead__video-element');
const mobileVideo = document.getElementById('c-page-masthead__mobile-video') || document.getElementById('c-event-masthead__mobile-video');
const $desktopVideoControl = $('.c-page-masthead__video-control, .c-event-masthead__video-control');
const $mobileVideoControl = $('.c-page-masthead__mobile-video-control, .c-event-masthead__mobile-video-control');


jQuery(function($) {

    function setupVideoControls(video, $control) {
        const $controlText = $control.find('span');
        const $controlIcon = $control.find('i');

        if (isAnimationReduced) {
            $control.attr('aria-pressed', 'true');
            $control.attr('aria-label', 'Play Video');
            $controlText.text('Play');
            $controlIcon.removeClass('fal fa-pause').addClass('fal fa-play');
            video.pause();
        }

        $control.click(function() {
            if (video.paused) {
                $control.attr('aria-pressed', 'false');
                $control.attr('aria-label', 'Pause Video');
                $controlText.text('Pause');
                $controlIcon.removeClass('fal fa-play').addClass('fal fa-pause');
                video.play();
            } else {
                $control.attr('aria-pressed', 'true');
                $control.attr('aria-label', 'Play Video');
                $controlText.text('Play');
                $controlIcon.removeClass('fal fa-pause').addClass('fal fa-play');
                video.pause();
            }
        });
    }

    if (desktopVideo) {
        setupVideoControls(desktopVideo, $desktopVideoControl);
    }
    if (mobileVideo) {
        setupVideoControls(mobileVideo, $mobileVideoControl);
    }
});